import React from "react";

export default function Policy() {
  return (
    <div style={{ padding: "1.5em" }}>
      <h2>
        <b>POLÍTICA DE PRIVACIDAD</b>
      </h2>
      <p style={{ marginTop: "2em" }}>Última actualización: 2023-01-13</p>

      <p>
        Arblu ("nosotros", "nuestro" o "nosotros") se compromete a proteger su
        privacidad. Esta Política de privacidad explica cómo Arblu recopila,
        utiliza y divulga su información personal. <br />
        <br />
        Esta Política de privacidad se aplica a nuestro sitio web y sus
        subdominios asociados (colectivamente, nuestro "Servicio") junto con
        nuestra aplicación, Arblu. Al acceder o utilizar nuestro Servicio,
        significa que ha leído, entendido y acepta nuestra recopilación,
        almacenamiento, uso y divulgación de su información personal como se
        describe en esta Política de privacidad y nuestros Términos de servicio.{" "}
        <br />
      </p>

      <h3>Definiciones y términos clave</h3>

      <p>
        Para ayudar a explicar las cosas con la mayor claridad posible en esta
        Política de privacidad, cada vez que se hace referencia a cualquiera de
        estos términos, se definen estrictamente como: <br />
        <br />
        -Cookie: pequeña cantidad de datos generados por un sitio web y
        guardados por su navegador web. Se utiliza para identificar su
        navegador, proporcionar análisis, recordar información sobre usted, como
        su preferencia de idioma o información de inicio de sesión. <br />{" "}
        <br />
        -Empresa: cuando esta política menciona “Empresa”, “nosotros”, “nos” o
        “nuestro”, se refiere a Reaction AI SPA, (Manuel Montt 1204,
        departamento 610, Providencia) que es responsable de su información bajo
        esta Política de Privacidad. <br /> <br />
        -País: donde radican Arblu o los dueños/fundadores de Arblu, en este
        caso es la República de Chile. <br /> <br />
        -Cliente: se refiere a la empresa, organización o persona que se
        registra para utilizar el Servicio Arblu para gestionar las relaciones
        con sus consumidores o usuarios del servicio. <br /> <br />
        -Dispositivo: cualquier dispositivo conectado a Internet, como un
        teléfono, tableta, computadora o cualquier otro dispositivo que pueda
        usarse para visitar Arblu y usar los servicios. <br />
        <br />
        -Dirección IP: a cada dispositivo conectado a Internet se le asigna un
        número conocido como dirección de protocolo de Internet (IP). Estos
        números suelen asignarse en bloques geográficos. Una dirección IP a
        menudo se puede usar para identificar la ubicación desde la cual un
        dispositivo se conecta a Internet. <br />
        <br />
        -Personal: se refiere a aquellas personas que son empleadas por Arblu o
        están bajo contrato para realizar un servicio en nombre de una de las
        partes. <br />
        <br />
        -Datos Personales: cualquier información que directa, indirectamente o
        en conexión con otra información —incluyendo un número de identificación
        personal— permita la identificación o identificabilidad de una persona
        natural. <br />
        <br />
        -Servicio: se refiere al servicio proporcionado por Arblu como se
        describe en los términos relativos (si están disponibles) y en esta
        plataforma. <br />
        <br />
        -Servicio de terceros: se refiere a anunciantes, patrocinadores de
        concursos, socios promocionales y de marketing, y otros que brindan
        nuestro contenido o cuyos productos o servicios creemos que pueden
        interesarle. <br />
        <br />
        -Sitio web: sitio de Arblu, al que se puede acceder a través de esta
        URL: https://www.arbluapp.com <br /> <br />
        -Usted: una persona o entidad registrada en Arblu para utilizar los
        Servicios. <br />
        <br />
      </p>

      <h3>¿Qué información recopilamos?</h3>

      <p>
        Recopilamos información sobre usted cuando visita nuestra aplicación, se
        registra en nuestro sitio, realiza un pedido, se suscribe a nuestro
        boletín informativo, responde a una encuesta o completa un formulario.{" "}
        <br />
        <br />
        -Nombre/Nombre de usuario. <br />
        <br />
        -Números de teléfono. <br />
        <br />
        -Correos electrónicos. <br />
        <br />
        -Fecha de nacimiento. <br />
        <br />
        -Contraseña. <br />
        <br />
      </p>

      <h3>¿Cómo usamos la información que recopilamos?</h3>

      <p>
        Cualquiera de la información que recopilamos de usted puede usarse de
        una de las siguientes maneras: <br />
        <br />
        -Para personalizar su experiencia (su información nos ayuda a responder
        mejor a sus necesidades individuales). <br />
        <br />
        -Para mejorar nuestra aplicación (nos esforzamos continuamente por
        mejorar nuestras ofertas de aplicaciones en función de la información y
        los comentarios que recibimos de usted). <br />
        <br />
        -Para mejorar el servicio al cliente (su información nos ayuda a
        responder de manera más efectiva a sus solicitudes de servicio al
        cliente y necesidades de soporte). <br />
        <br />
        -Para procesar transacciones-Para administrar un concurso, promoción,
        encuesta u otra característica del sitio-Para enviar correos
        electrónicos periódicos.
        <br />
        <br />
      </p>

      <h3>
        ¿Cuándo utiliza Arblu la información del usuario final de terceros?
      </h3>

      <p>
        Arblu recopilará los datos del usuario final necesarios para
        proporcionar los servicios de Arblu a nuestros clientes. <br />
        <br />
      </p>

      <h3>¿Cuándo utiliza Arblu información de clientes de terceros?</h3>

      <p>
        Recibimos cierta información de terceros cuando se comunica con
        nosotros. Por ejemplo, cuando nos envía su dirección de correo
        electrónico para mostrar interés en convertirse en cliente de Arblu,
        recibimos información de un tercero que brinda servicios automatizados
        de detección de fraude a Arblu. Ocasionalmente, también recopilamos
        información que se pone a disposición del público en sitios web de redes
        sociales. Puede controlar la cantidad de su información que los sitios
        web de redes sociales hacen públicos visitando estos sitios web y
        cambiando su configuración de privacidad. <br />
        <br />
      </p>

      <h3>¿Compartimos la información que recopilamos con terceros?</h3>

      <p>
        Podemos compartir la información que recopilamos con nuestras compañías
        afiliadas y socios comerciales actuales y futuros, y si estamos
        involucrados en una fusión, venta de activos u otra reorganización
        comercial, también podemos compartir o transferir su información
        personal y no personal a nuestros sucesores. <br />
        <br />
        Podemos contratar a terceros proveedores de servicios de confianza para
        que realicen funciones y nos brinden servicios, como alojamiento y
        mantenimiento de nuestros servidores y la aplicación, almacenamiento y
        administración de bases de datos, administración de correo electrónico,
        marketing de almacenamiento, procesamiento de tarjetas de crédito,
        servicio al cliente y cumplimiento de pedidos. para productos y
        servicios que puede comprar a través de la aplicación. Es probable que
        compartamos su información personal, y posiblemente alguna información
        no personal, con estos terceros para permitirles realizar estos
        servicios para nosotros y para usted. <br />
        <br /> Podemos compartir partes de los datos de nuestro archivo de
        registro, incluidas las direcciones IP, con fines de análisis con
        terceros, como socios de análisis web, desarrolladores de aplicaciones y
        redes publicitarias. Si se comparte su dirección IP, se puede usar para
        estimar la ubicación general y otros datos tecnológicos, como la
        velocidad de conexión, si ha visitado la aplicación en una ubicación
        compartida y el tipo de dispositivo utilizado para visitar la
        aplicación. Pueden agregar información sobre nuestra publicidad y lo que
        ve en la aplicación y luego proporcionar auditoría, investigación e
        informes para nosotros y nuestros anunciantes. <br />
        <br />
        También podemos divulgar información personal y no personal sobre usted
        al gobierno o a funcionarios encargados de hacer cumplir la ley o a
        terceros según lo consideremos necesario o apropiado, a nuestro
        exclusivo criterio, para responder a reclamos, procesos legales
        (incluidas citaciones), para proteger nuestra derechos e intereses o los
        de un tercero, la seguridad del público o de cualquier persona, para
        prevenir o detener cualquier actividad ilegal, poco ética o legalmente
        procesable, o para cumplir de otro modo con las órdenes judiciales,
        leyes, normas y reglamentos aplicables. <br />
        <br />
      </p>

      <h3>
        ¿Dónde y cuándo se recopila la información de los clientes y usuarios
        finales?
      </h3>

      <p>
        Arblu recopilará la información personal que nos envíe. También podemos
        recibir información personal sobre usted de terceros, como se describe
        anteriormente. <br />
        <br />{" "}
      </p>

      <h3>¿Cómo usamos su dirección de correo electrónico?</h3>

      <p>
        Al enviar su dirección de correo electrónico en esta aplicación, acepta
        recibir nuestros correos electrónicos. Puede cancelar su participación
        en cualquiera de estas listas de correo electrónico en cualquier momento
        haciendo clic en el enlace de exclusión u otra opción de cancelación de
        suscripción que se incluye en el correo electrónico respectivo. Solo
        enviamos correos electrónicos a las personas que nos han autorizado a
        contactarlos, ya sea directamente o a través de un tercero. No enviamos
        correos electrónicos comerciales no solicitados, porque odiamos el spam
        tanto como usted. Al enviar su dirección de correo electrónico, también
        acepta permitirnos usar su dirección de correo electrónico para la
        audiencia de clientes en sitios como Facebook, donde mostramos
        publicidad personalizada a personas específicas que han optado por
        recibir nuestras comunicaciones. Las direcciones de correo electrónico
        enviadas solo a través de la página de procesamiento de pedidos se
        utilizarán con el único propósito de enviarle información y
        actualizaciones relacionadas con su pedido. Sin embargo, si nos ha
        proporcionado el mismo correo electrónico a través de otro método,
        podemos usarlo para cualquiera de los fines establecidos en esta
        Política. Nota: Si en algún momento desea darse de baja de recibir
        futuros correos electrónicos, incluimos instrucciones detalladas para
        darse de baja en la parte inferior de cada correo electrónico. <br />
        <br />
      </p>

      <h3>¿Cuánto tiempo conservamos su información?</h3>

      <p>
        Mantenemos su información solo mientras la necesitemos para
        proporcionarle Arblu y cumplir con los propósitos descritos en esta
        política. Este también es el caso de cualquier persona con la que
        compartimos su información y que realiza servicios en nuestro nombre.
        Cuando ya no necesitemos usar su información y no sea necesario que la
        conservemos para cumplir con nuestras obligaciones legales o
        reglamentarias, la eliminaremos de nuestros sistemas o la
        despersonalizaremos para que no podamos identificarlo. <br />
        <br />
      </p>

      <h3>¿Cómo protegemos tu información?</h3>
      <p>
        Implementamos una variedad de medidas de seguridad para mantener la
        seguridad de su información personal cuando realiza un pedido o ingresa,
        envía o accede a su información personal. Ofrecemos el uso de un
        servidor seguro. Toda la información confidencial/crediticia
        suministrada se transmite a través de la tecnología Secure Socket Layer
        (SSL) y luego se cifra en nuestra base de datos para que solo puedan
        acceder aquellos autorizados con derechos especiales de acceso a dichos
        sistemas, y se les exige que mantengan la información confidencial. Sin
        embargo, no podemos asegurar ni garantizar la seguridad absoluta de
        cualquier información que transmita a Arblu ni garantizar que no se
        pueda acceder, divulgar, modificar, modificar o acceder a su información
        en el Servicio. <br />
        <br />
      </p>

      <h3>¿Mi información podría ser transferida a otros países?</h3>

      <p>
        Se incorpora Arblu en la República de Chile. La información recopilada a
        través de nuestro sitio web, a través de interacciones directas con
        usted o del uso de nuestros servicios de ayuda puede transferirse de vez
        en cuando a nuestras oficinas o personal, o a terceros, ubicados en todo
        el mundo, y puede verse y alojarse en cualquier lugar en el mundo,
        incluidos los países que pueden no tener leyes de aplicación general que
        regulen el uso y la transferencia de dichos datos. En la máxima medida
        permitida por la ley aplicable, al usar cualquiera de los anteriores,
        usted voluntariamente acepta la transferencia transfronteriza y el
        alojamiento de dicha información.
        <br />
        <br />
      </p>

      <h3>¿La información recopilada a través del Servicio Arblu es segura?</h3>

      <p>
        Tomamos precauciones para proteger la seguridad de su información.
        Contamos con procedimientos físicos, electrónicos y administrativos para
        ayudar a salvaguardar, evitar el acceso no autorizado, mantener la
        seguridad de los datos y usar correctamente su información. Sin embargo,
        ni las personas ni los sistemas de seguridad son infalibles, incluidos
        los sistemas de encriptación. Además, las personas pueden cometer
        delitos intencionales, cometer errores o no seguir las políticas. Por lo
        tanto, aunque hacemos esfuerzos razonables para proteger su información
        personal, no podemos garantizar su seguridad absoluta. Si la ley
        aplicable impone algún deber no renunciable de proteger su información
        personal, usted acepta que la mala conducta intencional será el estándar
        utilizado para medir nuestro cumplimiento con ese deber.
        <br />
        <br />
      </p>

      <h3>¿Puedo actualizar o corregir mi información?</h3>

      <p>
        Los derechos que tiene para solicitar actualizaciones o correcciones a
        la información que recopila Arblu dependen de su relación con Arblu. El
        personal puede actualizar o corregir su información según se detalla en
        nuestras políticas internas de empleo de la empresa. <br />
        <br />
        Los clientes tienen derecho a solicitar la restricción de ciertos usos y
        divulgaciones de información de identificación personal de la siguiente
        manera. Puede comunicarse con nosotros para (1) actualizar o corregir su
        información de identificación personal, (2) cambiar sus preferencias con
        respecto a las comunicaciones y otra información que recibe de nosotros,
        o (3) eliminar la información de identificación personal mantenida sobre
        usted en nuestro sistemas (sujeto al párrafo siguiente), cancelando su
        cuenta. Dichas actualizaciones, correcciones, cambios y eliminaciones no
        tendrán efecto en otra información que mantenemos, o información que
        hayamos proporcionado a terceros de acuerdo con esta Política de
        privacidad antes de dicha actualización, corrección, cambio o
        eliminación. Para proteger su privacidad y seguridad, podemos tomar
        medidas razonables (como solicitar una contraseña única) para verificar
        su identidad antes de otorgarle acceso a su perfil o realizar
        correcciones. Usted es responsable de mantener en secreto su contraseña
        única y la información de su cuenta en todo momento. <br />
        <br />
        Debe tener en cuenta que no es tecnológicamente posible eliminar todos y
        cada uno de los registros de la información que nos ha proporcionado de
        nuestro sistema. La necesidad de hacer una copia de seguridad de
        nuestros sistemas para proteger la información de pérdidas inadvertidas
        significa que puede existir una copia de su información en un formato
        que no se puede borrar y que será difícil o imposible de localizar para
        nosotros. Inmediatamente después de recibir su solicitud, toda la
        información personal almacenada en las bases de datos que usamos
        activamente y otros medios de fácil búsqueda se actualizarán,
        corregirán, cambiarán o eliminarán, según corresponda, tan pronto como
        sea razonable y técnicamente posible. <br />
        <br />
        Si es un usuario final y desea actualizar, eliminar o recibir cualquier
        información que tengamos sobre usted, puede hacerlo poniéndose en
        contacto con la organización de la que es cliente. <br />
        <br />
      </p>

      <h3>Personal.</h3>
      <p>
        Si usted es un trabajador o solicitante de Arblu, recopilamos la
        información que nos proporciona voluntariamente. Usamos la información
        recopilada con fines de recursos humanos para administrar los beneficios
        a los trabajadores y seleccionar a los solicitantes. <br />
        <br />
      </p>

      <p>
        Puede comunicarse con nosotros para (1) actualizar o corregir su
        información, (2) cambiar sus preferencias con respecto a las
        comunicaciones y otra información que recibe de nosotros, o (3) recibir
        un registro de la información que tenemos sobre usted. Dichas
        actualizaciones, correcciones, cambios y eliminaciones no tendrán efecto
        en otra información que mantenemos, o información que hayamos
        proporcionado a terceros de acuerdo con esta Política de privacidad
        antes de dicha actualización, corrección, cambio o eliminación. <br />
        <br />
      </p>

      <h3>Venta de Negocios.</h3>

      <p>
        Nos reservamos el derecho de transferir información a un tercero en el
        caso de una venta, fusión u otra transferencia de todos o
        sustancialmente todos los activos de Arblu o cualquiera de sus Afiliados
        Corporativos (como se define aquí), o esa parte de Arblu o cualquiera de
        sus Afiliadas Corporativas a las que se relaciona el Servicio, o en el
        caso de que descontinuemos nuestro negocio o presentemos una petición o
        hayamos presentado en nuestra contra una petición de quiebra,
        reorganización o procedimiento similar, siempre que el tercero acepte
        adherirse a los términos de esta Política de Privacidad. <br />
        <br />
      </p>

      <h3>Afiliados.</h3>

      <p>
        Podemos divulgar información (incluida la información personal) sobre
        usted a nuestros afiliados corporativos. A los fines de esta Política de
        privacidad, "Afiliado corporativo" significa cualquier persona o entidad
        que directa o indirectamente controle, sea controlada o esté bajo el
        control común de Arblu, ya sea por propiedad o de otra manera. Cualquier
        información relacionada con usted que proporcionemos a nuestros
        Afiliados Corporativos será tratada por dichos Afiliados Corporativos de
        acuerdo con los términos de esta Política de Privacidad. <br />
        <br />
      </p>

      <h3>Ley que rige.</h3>

      <p>
        Esta Política de privacidad se rige por las leyes de la República de
        Chile sin tener en cuenta su disposición sobre conflicto de leyes. Usted
        acepta la jurisdicción exclusiva de los tribunales en relación con
        cualquier acción o disputa que surja entre las partes en virtud o en
        relación con esta Política de privacidad, excepto aquellas personas que
        puedan tener derechos para presentar reclamos bajo el Escudo de
        privacidad o el marco suizo-estadounidense. <br />
        <br />
        Las leyes de la República de Chile, excluyendo sus conflictos de leyes,
        regirán este Acuerdo y su uso de la aplicación. Su uso de la aplicación
        también puede estar sujeto a otras leyes locales, estatales, nacionales
        o internacionales. <br />
        <br />
        Al usar Arblu o contactarnos directamente, significa que acepta esta
        Política de privacidad. Si no está de acuerdo con esta Política de
        privacidad, no debe interactuar con nuestro sitio web ni utilizar
        nuestros servicios. El uso continuo del sitio web, el compromiso directo
        con nosotros o la publicación de cambios a esta Política de privacidad
        que no afecten significativamente el uso o la divulgación de su
        información personal significará que acepta esos cambios. <br />
        <br />
      </p>

      <h3>Tu consentimiento.</h3>

      <p>
        Hemos actualizado nuestra Política de privacidad para brindarle total
        transparencia sobre lo que se configura cuando visita nuestro sitio y
        cómo se usa. Al usar nuestra aplicación, registrar una cuenta o realizar
        una compra, usted acepta nuestra Política de privacidad y acepta sus
        términos.
        <br />
        <br />
      </p>

      <h3>Enlaces a otros sitios web.</h3>

      <p>
        Esta Política de privacidad se aplica solo a los Servicios. Los
        Servicios pueden contener enlaces a otros sitios web no operados o
        controlados por Arblu. No somos responsables del contenido, la precisión
        o las opiniones expresadas en dichos sitios web, y dichos sitios web no
        son investigados, monitoreados o verificados por nuestra precisión o
        integridad. Recuerde que cuando utiliza un enlace para ir de los
        Servicios a otro sitio web, nuestra Política de privacidad ya no está
        vigente. Su navegación e interacción en cualquier otro sitio web,
        incluidos aquellos que tienen un enlace en nuestra plataforma, están
        sujetos a las reglas y políticas propias de ese sitio web. Dichos
        terceros pueden usar sus propias cookies u otros métodos para recopilar
        información sobre usted.
        <br />
        <br />
      </p>

      <h3>Privacidad de los niños.</h3>

      <p>
        No nos dirigimos a ninguna persona menor de 18 años. No recopilamos a
        sabiendas información de identificación personal de ninguna persona
        menor de 18 años. Si es padre o tutor y sabe que su hijo nos ha
        proporcionado Datos personales, comuníquese con Nosotros. Si nos damos
        cuenta de que hemos recopilado Datos personales de cualquier persona
        menor de 18 años sin verificación del consentimiento de los padres,
        tomamos medidas para eliminar esa información de Nuestros servidores.
        <br />
        <br />
      </p>

      <h3>Cambios a nuestra política de privacidad.</h3>

      <p>
        Podemos cambiar nuestro Servicio y nuestras políticas, y es posible que
        debamos realizar cambios en esta Política de privacidad para que
        reflejen con precisión nuestro Servicio y nuestras políticas. A menos
        que la ley exija lo contrario, le notificaremos (por ejemplo, a través
        de nuestro Servicio) antes de realizar cambios en esta Política de
        privacidad y le daremos la oportunidad de revisarlos antes de que entren
        en vigencia. Luego, si continúa utilizando el Servicio, estará sujeto a
        la Política de privacidad actualizada. Si no desea aceptar esta o
        cualquier Política de privacidad actualizada, puede eliminar su cuenta.
      </p>

      <h3>Servicios de terceros.</h3>

      <p>
        Podemos mostrar, incluir o poner a disposición contenido de terceros
        (incluidos datos, información, aplicaciones y otros servicios de
        productos) o proporcionar enlaces a sitios web o servicios de terceros
        ("Servicios de terceros").
        <br />
        <br />
        Usted reconoce y acepta que Arblu no será responsable de ningún Servicio
        de terceros, incluida su precisión, integridad, puntualidad, validez,
        cumplimiento de derechos de autor, legalidad, decencia, calidad o
        cualquier otro aspecto de los mismos. Arblu no asume y no tendrá ninguna
        obligación o responsabilidad hacia usted o cualquier otra persona o
        entidad por los Servicios de terceros.
        <br />
        <br />
        Los Servicios de terceros y los enlaces a los mismos se proporcionan
        únicamente para su comodidad y usted accede a ellos y los utiliza bajo
        su propio riesgo y sujeto a los términos y condiciones de dichos
        terceros.
        <br />
        <br />
      </p>

      <h3>Contáctenos.</h3>

      <p>
        No dude en ponerse en contacto con nosotros si tiene alguna pregunta.
        <br />
        <br />
        -Vía Correo Electrónico: <b>ffernandez@arbluapp.com</b>
      </p>
    </div>
  );
}
